// extracted by mini-css-extract-plugin
export default {"container":"tab_2Q9vP"};